import { render, staticRenderFns } from "./ReplacementRuleConfigForm.vue?vue&type=template&id=71fe6bc3"
import script from "./ReplacementRuleConfigForm.vue?vue&type=script&lang=js"
export * from "./ReplacementRuleConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports